import { getHelpInquiries } from '@/services/help.service';
import { postUserInquiry } from '@/services/sprt.service';

const state = {
  categories: [],
  confirm: {},
  userInquiry: {},
  selectedCam: null,
  allowCam: false,
};

// Getter functions
const getters = {};

// Mutations
const mutations = {
  setTopicInput(state, payload) {
    const categoryIndex = state.categories.findIndex((item) => {
      return item.id === payload.categoryId;
    });

    if (categoryIndex !== -1) {
      const topicIndex = state.categories[categoryIndex].sub_topic.findIndex(
        (item) => {
          return item.id === payload.topicId;
        }
      );
      if (topicIndex !== -1) {
        state.categories[categoryIndex].sub_topic[topicIndex].input =
          payload.input;
      }
    }
  },
  setQuestionInput(state, payload) {
    const categoryIndex = state.categories.findIndex((item) => {
      return item.id === payload.categoryId;
    });

    if (categoryIndex !== -1) {
      const topicIndex = state.categories[categoryIndex].sub_topic.findIndex(
        (item) => {
          return item.id === payload.topicId;
        }
      );
      if (topicIndex !== -1) {
        const questionIndex = state.categories[categoryIndex].sub_topic[
          topicIndex
        ].list.findIndex((item) => {
          return item.id === payload.questionId;
        });
        if (questionIndex !== -1) {
          state.categories[categoryIndex].sub_topic[topicIndex].list[
            questionIndex
          ].input = payload.input;
        }
      }
    }
  },
  setCategories(state, payload) {
    state.categories = payload;
  },
  setConfirm(state, payload) {
    state.confirm = payload;
  },
  setUserInquiry(state, payload) {
    state.userInquiry = payload;
  },
  setSelectedCam(state, payload) {
    state.selectedCam = payload;
  },
  setAllowCam(state, payload) {
    state.allowCam = payload;
  },
};

// Actions
const actions = {
  async fetchHelpInquiries({ commit }) {
    const result = await getHelpInquiries();
    commit(
      'setCategories',
      result.topic.map((cat, catIndex) => {
        cat.id = String(catIndex + 1);
        if (cat.sub_topic) {
          cat.sub_topic = cat.sub_topic.map((topic, topicIndex) => {
            topic.id = String(topicIndex + 1);
            topic.showCamSelect = topic.title === 'カメラについて';
            if (topic.list) {
              topic.list = topic.list.map((question, questionIndex) => {
                question.id = String(questionIndex + 1);
                question.index = questionIndex;
                if (question.answer) {
                  question.input = question.answer;
                }
                return question;
              });
            } else {
              topic.list = [];
            }
            return topic;
          });
        } else {
          cat.sub_topic = [];
        }
        return cat;
      })
    );
    return result.topic;
  },
  setTopicInput(context, payload) {
    context.commit('setTopicInput', payload);
  },
  setQuestionInput(context, payload) {
    context.commit('setQuestionInput', payload);
  },
  setConfirm(context, payload) {
    context.commit('setConfirm', payload);
  },
  async postUserInquiry({ commit }, payload) {
    const result = await postUserInquiry(payload);
    commit('setUserInquiry', result);
  },
  setSelectedCam(context, payload) {
    if (payload === null) {
      context.commit('setAllowCam', false);
    }
    context.commit('setSelectedCam', payload);
  },
  setAllowCam(context, payload) {
    context.commit('setAllowCam', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
